import React from "react"
import styled from "styled-components"
import PagesHero from "../shared/PagesHero"
import { useStaticQuery, graphql } from "gatsby"
import Title from "../shared/Title"
import bankIcon from "../../assist/icons/donate/ziraatLogo.svg"
import BankAccount from "./BankAccount"
import eur from "../../assist/icons/donate/eur.svg"
import tl from "../../assist/icons/donate/tl.svg"
import usd from "../../assist/icons/donate/usd.svg"
import Form from "../contact_us/Form"
const DonatePage = ({ lang }) => {
  const img = useStaticQuery(graphql`
    {
      strapiBanners(name: { eq: "donateBanner" }) {
        banner {
          childImageSharp {
            fluid(maxWidth: 1000, quality: 100) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    }
  `)
  const words = {
    ar: {
      linkName: "كيفية التبرع ",
      donateNow: "تبرع الأن",
      donateText1: `
      يمكنكم التبرع لدعم الحملات الموسمية وحملات الإستجابة الطارئة والمشاريع
      المتنوعة
      `,
      donateText2: `
      وذلك من خلال إرسال تبرعاتكم للحساب البنكي مع إرسال إيميل
      بتفاصيل المبلغ مرفق بصورة إشعار التحويل
      `,
      bankTitle: `معلومات حساب البنك الزراعي التركي`,
      eurCurr: "اليورو",
      usdCurr: "الدولار",
      tlCurr: "التركي",
      leaveMessageTitle: "اترك لنا رسالة",
      afterDonate: "بعد قيامك بالتبرع نرجوا تعبئة هذا النموزج",
      formLongText: "نص الرسالة... سبب التبرع",
      sendButton: "ارسل الرسالة",
    },
    en: {
      linkName: "How to Donate",
      donateNow: "Donate Now",
      donateText1: `You can donate to support seasonal campaigns, emergency response campaigns and various projects `,
      donateText2: `by sending your donations to the bank account and an email with the details of the amount with a copy of the transfer receipt.`,
      bankTitle: "Bank Account Information",
      eurCurr: "Euro",
      usdCurr: "Dollar",
      tlCurr: "turkish lira ",
      leaveMessageTitle: "Leave a message",
      afterDonate: "After your donation, please fill out this form",
      formLongText: "Your message – Reason of Donation...",
      sendButton: "Send message",
    },
    tr: {
      linkName: "Nasıl bağış yapabilirim",
      donateNow: "Bagış yap",
      donateText1: `
      Mevsimsel kampanyalarını, Acil yardım kampanyalarını ve değişik projeleri desteklemek için bağışta bulunabilirsiniz.
      `,
      donateText2: `
      Bağışlarınızı banka hesabına, bağış tutarının detaylaını bulunduran bir email ve transfer dekontunun bir nüshasını  göndererek bağış yapabilirsiniz.
      `,
      bankTitle: "Türkiye Ziraat Bankasının bilgileri",
      eurCurr: "Euro",
      usdCurr: "Dolar",
      tlCurr: "Türk lirası",
      leaveMessageTitle: "Bize mesaj bırak",
      afterDonate:
        "Bağışta bulunduktan sonra bu formu doldurmanızı rica ederiz.",
      formLongText: "Mesajın metni, Bağış sebebi...",
      sendButton: "mesaj gönder",
    },
  }
  const {
    linkName,
    donateNow,
    donateText1,
    donateText2,
    bankTitle,
    eurCurr,
    usdCurr,
    tlCurr,
    leaveMessageTitle,
    afterDonate,
    formLongText,
    sendButton,
  } = words[lang]
  return (
    <Wraper>
      <PagesHero
        image={img.strapiBanners.banner.childImageSharp.fluid}
        activeLink={linkName}
        className="divider"
        lang={lang}
      />

      <div className="content">
        <Title text={donateNow} width="100px" className="title" />
        <p className="donateText">
          {donateText1}
          <br />
          {donateText2}
        </p>
        <div className="accountInfo">
          <div className="container">
            <h2>{bankTitle}</h2>
            <img src={bankIcon} alt="bankIcon" className="bankIcon" />

            <div className="bankAccounts">
              <BankAccount
                image={eur}
                accountType={eurCurr}
                accountNumber="74454699-5003"
                iban="TR060001000043744
                546995003"
                lang={lang}
              />
              <BankAccount
                image={usd}
                accountType={usdCurr}
                accountNumber="74454699-5002"
                iban="TR330001000043744
                546995002"
                lang={lang}
              />
              <div className="tlAccount">
                <BankAccount
                  image={tl}
                  accountType={tlCurr}
                  accountNumber="74454699-5001"
                  iban="TR600001000043744
                546995001"
                  lang={lang}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="leaveMessage">
          <div className="container">
            <Title text={leaveMessageTitle} width="100px" className="title" />
            <p className="donateText">{afterDonate}</p>
            <Form text={formLongText} buttonText={sendButton} lang={lang}/>
          </div>
        </div>
      </div>
    </Wraper>
  )
}

export default DonatePage
const Wraper = styled.section`
  .divider {
    padding-top: 120px;
  }
  .content {
    text-align: center;
    .title {
      margin-top: 40px;
    }
    .donateText {
      font-size: 1.3rem;
      color: ${props => props.theme.g2};
      padding-bottom: 40px;
    }
    .accountInfo {
      background: ${props => props.theme.aboutback};
      border: 2px solid ${props => props.theme.borderColor};
      h2 {
        color: ${props => props.theme.dg};
        padding-top: 20px;
      }

      .bankIcon {
        width: 200px;
        padding: 20px 0;
      }
      .bankAccounts {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 20px;
        padding-bottom: 50px;
      }
    }
  }
  .leaveMessage {
    padding-bottom: 50px;
  }
  @media (max-width: 700px) {
    .accountInfo {
      .bankAccounts {
        grid-template-columns: 1fr 1fr !important;
        .tlAccount {
          grid-column-start: 1;
          grid-column-end: 3;
        }
      }
    }
  }
  @media (max-width: 460px) {
    .accountInfo {
      .bankAccounts {
        grid-template-columns: 1fr !important;
        .tlAccount {
          grid-column-start: 1;
          grid-column-end: 1;
        }
      }
    }
  }
`
